










































































































































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import InfiniteLoading from 'vue-infinite-loading';
import { IOrderDetails } from '../../../types/order-details';
import { TextOutput } from '../../../mixins';
import { Getter, State } from 'vuex-class';
import { IGame } from '../../../store/games/types';
import {
  TransactionHashType,
  transactionTypeByHash,
} from '../../../utils/transactionTypeByHash';
import { IInventoryCollection } from '../../../store/cms_content/types';

@Component({ components: { InfiniteLoading } })
export default class OrderDetails extends Mixins(TextOutput) {
  @Getter('inventoryIconForCollectionName', { namespace: 'cmsContent' })
  collectionIcons!: Record<string, IInventoryCollection | undefined>;
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];

  @Prop(Object)
  readonly orderDetails!: IOrderDetails;

  @Prop({ type: Boolean, default: true })
  readonly isViewInventoryButtonVisible!: boolean;

  productTypes = {
    ethereum: ['item-pack', 'item'],
    gyri: ['galachain-item', 'galachain-allowance', 'item-pack-mix'],
    game: ['game-gem', 'spidertanks-profile-item'],
  };

  filterSymbol(symbol: string) {
    return symbol?.replace(/\[ETH\]|\[GC\]|\[GalaChain\]|\[GYRI\]/, '');
  }

  get gameIcon() {
    return this.collectionIcons[this?.game?.name || '']?.inventoryImage;
  }

  get totals() {
    const { price, symbol } = this.orderDetails.selectedPrice;
    if (this.orderDetails.transactionFee && !this.isCreditCard) {
      const {
        fee: transactionFee,
        currency: transactionCurrency,
      } = this.orderDetails.transactionFee;
      if (transactionCurrency === symbol) {
        return [
          {
            total: parseFloat(price) + (transactionFee ?? 0),
            currency: symbol,
          },
        ];
      } else {
        return [
          { total: parseFloat(price), currency: symbol },
          { total: transactionFee, currency: transactionCurrency },
        ];
      }
    }
    return [{ total: price, currency: symbol }];
  }

  get isCreditCard() {
    return this.orderDetails.selectedPrice.symbol === 'USD';
  }

  get inventoryButtonText() {
    const productType = this.orderDetails.product.type;
    if (this.productTypes.ethereum.includes(productType)) {
      return 'View Inventory';
    } else if (this.productTypes.gyri.includes(productType)) {
      return 'View in Inventory';
    } else if (this.productTypes.game.includes(productType)) {
      return 'Play Game';
    }
  }

  get inventoryButtonLink() {
    const productType = this.orderDetails.product.type;
    if (this.productTypes.ethereum.includes(productType)) {
      return '/inventory';
    } else if (this.productTypes.gyri.includes(productType)) {
      return '/inventory';
    } else if (this.productTypes.game.includes(productType)) {
      return this.game ? `/games/${this.game?.route}` : null;
    }
  }

  get game() {
    return this.games.find(
      game => game.name === this.orderDetails.product.game,
    );
  }

  get paymentMethod() {
    if (this.orderDetails?.paymentHash) {
      const transactionHashType = transactionTypeByHash(
        this.orderDetails.paymentHash,
      );
      if (transactionHashType === TransactionHashType.STRIPE) {
        return this.$t(`components.wallet.paymentPicker.stripe`);
      } else if (transactionHashType === TransactionHashType.MOONPAY) {
        return this.$t(`components.wallet.paymentPicker.moonpay`);
      }
    }
    return this.filterGyriText(this.orderDetails.selectedPrice.symbol);
  }

  get completedRebate() {
    const rebate = this.orderDetails?.rebate?.tokens?.[0];

    if (rebate) {
      const tokenType =
        rebate.type === 'galachain-allowance' ? 'GALA' : 'tokens';

      if (rebate.usdAmount) {
        return {
          usdAmount: rebate.usdAmount,
        };
      } else if (rebate.quantity && rebate.type) {
        return {
          quantity: rebate.quantity.toFixed(2),
          tokenType,
        };
      }
    }

    return null;
  }

  get truncatedTransactionHash() {
    const hash = this.orderDetails.paymentHash;
    if (hash) {
      const string = `${hash.slice(0, 6)}....${hash.substr(
        hash.length - 4,
        hash.length,
      )}`;
      return string;
    }
    return '';
  }
}
